<template>
  <div class="element-style-panel">
    <component :is="currentPanelComponent"></component>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import {useMainStore} from '@/store'
import { ElementTypes } from '@/types/slides'
import DragDropStylePanel from './DragDropStylePanel.vue'
import ShapeStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/ShapeStylePanel.vue";
import LineStylePanel from "@/views/Editor/Toolbar/ElementStylePanel/LineStylePanel.vue";

const panelMap = {
  [ElementTypes.SHAPE]: ShapeStylePanel,
  [ElementTypes.LINE]: LineStylePanel,
  [ElementTypes.DRAG_DROP]: DragDropStylePanel
}

const { handleElement } = storeToRefs(useMainStore())

const currentPanelComponent = computed(() => {
  return handleElement.value ? (panelMap[handleElement.value.type] || panelMap['dragdrop']) : panelMap['dragdrop']
})
</script>
